/* eslint-disable no-tabs */

(() => {
    const initPWS = async ({ detail: pwsHelpers }) => {
      const {
        BASE_URL,
        COUNTRY_CODE,
        getAccountDetails,
        getPartyDetails,
        setLocalStorage,
        setSessionStorage,
        removeLocalStorage,
        getLocalStorage,
        renderSingleBanner,
        renderMultiBanner,
        renderInactiveBanner,
        renderInactiveParty,
      } = pwsHelpers;
      async function renderBannerAfterDOM(fun) {
        if (document.readyState === "interactive" || document.readyState === "complete") {
          fun();
        } else {
          await new Promise(resolve => {
            document.addEventListener("DOMContentLoaded", resolve);
          });
          fun();
        }
      }
  
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
  
      const replaceSearchParams = () => {
        if (queryString.startsWith("?fbclid")) return;
        if (queryString.includes("/?fbclid") || queryString.includes("?fbclid")) {
          window.location.href = queryString
            .replace("/?fbclid", "&fbclid")
            .replace("?fbclid", "&fbclid");
        }
      }
      replaceSearchParams();
      // Params ID and Name are passed from the URL
      const regexedConsultantId = queryString.match(/twcid=([^&]*)/i)
      const regexedPartyId = queryString.match(/twpid=([^&]*)/i)
      const consultantParamId =
      urlParams.get("twcId") || urlParams.get("consultant") || regexedConsultantId? regexedConsultantId[1] :null;
      const partyParamId = urlParams.get("twpId") || regexedPartyId?regexedPartyId[1] : null ;
      console.log("consultantParamId", consultantParamId);
  
      // Get the consultant details from the local storage
      const getConsultantAndPartyDetails = () => {
        let consultant = JSON.parse(getLocalStorage("consultant"));
        let party = JSON.parse(getLocalStorage("party"));
        return { consultant, party };
      };
  
      let { consultant, party } = getConsultantAndPartyDetails();
  
      function makeUrlWithParams() {
        let params;
  
        if (party && consultant) {
          params = `?twcId=${consultant?.consultantId}&twpId=${party?.partyId}`;
        } else if (consultant) {
          params = `?twcId=${consultant?.consultantId}`;
        }
        else if (localStorage.getItem("twcid") !== null || localStorage.getItem("twpid") !== null) {
          const queryString = window.location.search;
          const regexedConsultantId = queryString.match(/twcid=([^&]*)/i)
          const regexedPartyId = queryString.match(/twpid=([^&]*)/i)
          if (regexedConsultantId === null && regexedPartyId === null) {
            const newLink = new URL(location.href);
            localStorage.getItem("twcid") && newLink.searchParams.set("twcId", localStorage.getItem("twcid"));
            localStorage.getItem("twpid") && newLink.searchParams.set("twpId", localStorage.getItem("twpid"));
            //window.location.href = newLink;
            window.history.pushState(null, null, "?" + newLink.searchParams);
          }
        }
  
        return params;
      }
      
      function changeShareLinks() {
        const params = makeUrlWithParams();
        changeLinks(".article-content-icon a", params);
        changeLinks(".Product__ShareItem", params);
      }
  
      function changeLinks(selector, params) {
        const links = document.querySelectorAll(selector);
        if (!links) return;
        links.forEach((link) => {
          link.href = link.href + params;
        });
      }
  
      function setParamsFromLocalStorage() {
        const queryString = window.location.search;
        const regexedConsultantId = queryString.match(/twcid=([^&]*)/i)
        const regexedPartyId = queryString.match(/twpid=([^&]*)/i)
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.get("twcId") || urlParams.get("twpId")) return;
        if ( (regexedPartyId && regexedPartyId[1]) || (regexedConsultantId && regexedConsultantId[1]) ) return 
        if (consultant) {
        urlParams.set("twcId", consultant?.consultantId);
        }
        if (party) {
          urlParams.set("twpId", party?.partyId);
        }
        window.history.replaceState(null, null, "?" + urlParams);
      }
  
      const setRepresentativeLinks = (value = "MyStory") => {
        let changeButtonUrl = `https://my.tupperware.com/${consultant.consultantWebSite}/${value}`;

        // USCA-5431
        const website = window.Shopify.shop;
        const shop_country = window.Shopify.country;

     if (shop_country == 'CA')      
     {
      switch (website) {
        case "pws-dev-us.myshopify.com":
          changeButtonUrl = `https://caoci-qa.tupperware.ca/${consultant.consultantWebSite}/${value}`;
          break;
        case "pws-dev-ca.myshopify.com":
          changeButtonUrl = `https://caoci-qa.tupperware.ca/${consultant.consultantWebSite}/${value}`;
          break;
        default:
          changeButtonUrl = `https://my.tupperware.ca/${consultant.consultantWebSite}/${value}`;
      }
    }
    else
    {
      switch (website) {
        case "pws-dev-us.myshopify.com":
          changeButtonUrl = `https://myoci-qa.tupperware.com/${consultant.consultantWebSite}/${value}`;
          break;
        default:
          changeButtonUrl = `https://my.tupperware.com/${consultant.consultantWebSite}/${value}`;
      }
    }

        /*
        switch (website) {
          case "pws-dev-us.myshopify.com":
            changeButtonUrl = `https://myoci-qa.tupperware.com/${consultant.consultantWebSite}/${value}`;
            break;
          case "tupperware-usa.myshopify.com":
            changeButtonUrl = `https://my.tupperware.com/${consultant.consultantWebSite}/${value}`;
            break;
          case "tupperware-ca.myshopify.com":
            changeButtonUrl = `https://my.tupperware.ca/${consultant.consultantWebSite}/${value}`;
            break;
          case "pws-dev-ca.myshopify.com":
            changeButtonUrl = `https://myoci-qa.tupperware.ca/${consultant.consultantWebSite}/${value}`;
            break;
          default:
            changeButtonUrl = `https://my.tupperware.com/${consultant.consultantWebSite}/${value}`;
        }
            */
        return changeButtonUrl;
      }
  
      const changeRepresentativeLinks = () => {
        const links = document.querySelectorAll(
          '[data-secondary-link]'
        );
        const linksFromContentPages =
          document.querySelectorAll("[data-pws-link]");
  
        linksFromContentPages.length > 0 && linksFromContentPages.forEach((element) => {
          const value = element.getAttribute("data-pws-link")
          element.href = `${setRepresentativeLinks(value)}`;
          if (document.title.includes("Trailblazer")) {
            element.title = element.innerText = "JOIN TODAY";
            document.getElementById("landingPage__button").innerText = "JOIN TODAY";
            document.getElementById("landingPage__button").href = `${setRepresentativeLinks(value)}`;
          }
          else {
            element.title = element.innerText = "Contact Your Rep";
          }
        });
  
        links.forEach((element) => {
          if (consultant && consultant.consultantWebSite) {
            element.href = `${setRepresentativeLinks()}`;
            if (document.title.includes("Trailblazer")) {
              element.title = element.innerText = "JOIN TODAY";
              document.getElementById("landingPage__button").innerText = "JOIN TODAY";
              document.getElementById("landingPage__button").href = `${setRepresentativeLinks(value)}`;
            }
            else {
              element.title = element.innerText = "Contact Your Rep";
            }
          }
        });
      };
  
      if (consultantParamId && partyParamId === null) {
        removeLocalStorage("party");
      }
  
      async function fetchWithRetryAndTimeout(promises, maxRetries, delay, timeout) {
        let retryCount = 0;
        let isLastCall = false;
  
        while (retryCount <= maxRetries) {
          try {
            isLastCall = retryCount === maxRetries; // Check if it's the last call
  
            if (isLastCall) {
              renderBannerAfterDOM(() => {
                renderSingleBanner(consultantParamId);
              });
  
              await new Promise((resolve) => {
                console.log('Waiting for response...');
                setTimeout(resolve, 1000);
              });
            }
            const [consultantDetails, partyDetails] = await Promise.race([
              Promise.allSettled(promises),
              new Promise((_, reject) => setTimeout(() => reject(new Error('Request timed out')), timeout))
            ]);
  
            return [consultantDetails, partyDetails];
          } catch (error) {
            console.log(`Error occurred: ${error}`);
            retryCount++;
  
            console.log(`Retrying in ${delay} milliseconds...`);
            await new Promise((resolve) => setTimeout(resolve, delay));
          }
        }
      }
  
      try {
        // if URL has params, do API call and set local storage
        const promises = [];
  
        let store = "US";
        
        // USCA-5431
        store = window.Shopify.country;

        if (window.location.host.includes("tupperware.ca") || window.location.host.includes("pws-dev-ca.myshopify.com")) {
          store = "CA"
        }
  
        //if (consultantParamId && !consultantParamId.toString().startsWith(store)) {
        //  throw new Error("Invalid Country for Consultant ID");
        //}

        if (
          consultantParamId &&
          consultantParamId !== (consultant && consultant.id)
        ) {
          promises.push(
            getAccountDetails(BASE_URL, COUNTRY_CODE, consultantParamId)
          );
        } else {
          promises.push(Promise.resolve(null));
        }
        if (partyParamId && partyParamId !== (party && party.id)) {
          promises.push(getPartyDetails(BASE_URL, COUNTRY_CODE, partyParamId));
        } else {
          promises.push(Promise.resolve(null));
        }
  
        // Usage:
        const maxRetries = 2;
        const delay = 100; // milliseconds
        const timeout = 2000; // milliseconds
  
        const [consultantDetails, partyDetails] = await fetchWithRetryAndTimeout(promises, maxRetries, delay, timeout);
  
        if(partyDetails.status === "rejected") {
          removeLocalStorage('party');
        }
  
        if(consultantDetails.status === "rejected") {
          removeLocalStorage('consultant');
        }
  
        if (consultantDetails.value !== null) {
          const { Account } = consultantDetails.value;
  
          consultant = {
            id: consultantParamId,
            consultantId: Account.Code,
            consultantName: Account.Name,
            consultantType: Account.AccountType,
            consultantRegion: Account.Region,
            consultantWebSite: Account.WebSite,
            AccountStatus: Account.AccountStatus,
          };
  
          if (consultant.AccountStatus === "Inactive") {
            renderBannerAfterDOM(() => renderInactiveBanner());
            return;
          }
          setLocalStorage("consultant", JSON.stringify(consultant));
          setSessionStorage("consultant", JSON.stringify(consultant));
        }
  
  
        if (partyDetails.value !== null) {
          const { Party } = partyDetails.value;
  
          party = {
            id: partyParamId,
            partyId: Party.Code,
            partyStartDate: Party.StartDate,
            partyTimeZone: Party.TimeZone,
            partyName: Party.Name,
            PartyStatus: Party.PartyStatus,
          };
  
          if (
            party.PartyStatus === "Closed" ||
            party.PartyStatus === "Cancelled"
          ) {
            renderBannerAfterDOM(() =>
              renderInactiveParty(
                consultant.consultantWebSite,
                consultant.consultantName
              )
            );
            changeRepresentativeLinks();
            return;
          }
  
          setLocalStorage("party", JSON.stringify(party));
          setSessionStorage("party", JSON.stringify(party));
        }
  
      } catch (error) {
        if (error instanceof Error) {
          // eslint-disable-next-line no-alert
          let { consultant, party } = getConsultantAndPartyDetails();
  
          console.log(
            `Network Error, try again in a few minutes: ${error.message}`
          );
  
          if (consultant === null && party === null) {
            renderBannerAfterDOM(() => {
              renderInactiveBanner();
            });
          } else if (consultant && party === null) {
            renderBannerAfterDOM(() => {
              renderInactiveParty(
                consultant.consultantWebSite,
                consultant.consultantName
              );
            });
          }
          changeShareLinks();
          return;
        }
  
        // eslint-disable-next-line no-alert
        alert(
          "Error getting consultant details, please check the Id and try again"
        );
        return;
      }
      const consultantName =
        (consultant && consultant.consultantName) || consultantParamId;
  
      if (party) {
        // eslint-disable-next-line no-undef
        const dateTime = new Date(party.partyStartDate);
        const date = dateTime.toLocaleDateString("en-US", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        });
        const partyName = party.partyName || partyParamId;
        const partyTime = date;
        const timeZone = party.partyTimeZone;
        let changePartyUrl = `https://my.tupperware.com/${consultant.consultantWebSite}/events`;
  
        const website = window.Shopify.shop;
        const shop_country = window.Shopify.country;

        // USCA-5431
     if (shop_country == 'CA')      
     {
      switch (website) {
        case "pws-dev-us.myshopify.com":
          changePartyUrl = `https://caoci-qa.tupperware.ca/${consultant.consultantWebSite}/events`;
          break;
        case "pws-dev-ca.myshopify.com":
          changePartyUrl = `https://caoci-qa.tupperware.ca/${consultant.consultantWebSite}/events`;
          break;
        default:
          changePartyUrl = `https://my.tupperware.ca/${consultant.consultantWebSite}/events`;
      }
    }
    else
    {
      switch (website) {
        case "pws-dev-us.myshopify.com":
          changePartyUrl = `https://myoci-qa.tupperware.com/${consultant.consultantWebSite}/events`;
          break;
        default:
          changePartyUrl = `https://my.tupperware.com/${consultant.consultantWebSite}/events`;
      }
    }

        /*
        switch (website) {
          case "pws-dev-us.myshopify.com":
            changePartyUrl = `https://myoci-qa.tupperware.com/${consultant.consultantWebSite}/events`;
            break;
          case "tupperware-usa.myshopify.com":
            changePartyUrl = `https://my.tupperware.com/${consultant.consultantWebSite}/events`;
            break;
          case "tupperware-ca.myshopify.com":
            changePartyUrl = `https://my.tupperware.ca/${consultant.consultantWebSite}/events`;
            break;
          case "pws-dev-ca.myshopify.com":
            changePartyUrl = `https://myoci-qa.tupperware.ca/${consultant.consultantWebSite}/events`;
            break;
          default:
            changePartyUrl = `https://my.tupperware.com/${consultant.consultantWebSite}/events`;
        }
        
        */
  
        if (consultant) {
          if (consultantParamId && partyParamId === null) {
            setParamsFromLocalStorage();
            renderBannerAfterDOM(() => {
              renderSingleBanner(consultantName, consultant.consultantWebSite);
              changeShareLinks();
            });
          } else {
            console.log("render multiple banner");
            setParamsFromLocalStorage();
            renderBannerAfterDOM(() => {
              renderMultiBanner(
                partyName,
                partyTime,
                timeZone,
                consultantName,
                changePartyUrl,
                consultant.consultantWebSite
              );
              changeShareLinks();
            });
          }
        }
        changeRepresentativeLinks();
        return;
      }
      if (consultant && !party) {
        setParamsFromLocalStorage();
        renderBannerAfterDOM(() => {
          renderSingleBanner(consultantName, consultant.consultantWebSite);
          changeShareLinks();
        });
      }
      else if (!consultant && !party && localStorage.getItem("twcid") !== null && localStorage.getItem("twpid") === null) {
        renderBannerAfterDOM(() => {
          renderInactiveBanner();
          changeShareLinks();
        });
      }
      else if (!consultant && !party && localStorage.getItem("twcid") !== null && localStorage.getItem("twpid") !== null) {
        renderBannerAfterDOM(() => {
          renderInactiveBanner();
          changeShareLinks();
        });
      }
      changeRepresentativeLinks();
    };
  
    const pwsHelpersKey = "__pwsHelpers";
    const pwsHelpers = window[pwsHelpersKey];
  
    return pwsHelpers && pwsHelpers.ready
      ? setTimeout(initPWS, 1, { detail: pwsHelpers })
      : document.addEventListener(`${pwsHelpersKey}_ready`, initPWS);
  })();
  